import { PwaInstall } from '@marque/ui'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { DialogHost, ViewportProvider } from '@marque/ui'
import { installStaleBuildRecovery } from '@marque/utils'
import { router } from './router'
import './index.css'

// AB#2558 — the tenant-detail tabs are lazyRouteComponent-split, so a tab left open across a
// deploy 404s on the next tab it opens. Reload once to pick up the new build. Central has no error
// boundary, so this window listener is the whole recovery here.
installStaleBuildRecovery()

const queryClient = new QueryClient({
    defaultOptions: { queries: { staleTime: 60_000, retry: false } },
})

const rootElement = document.getElementById('root')
if (rootElement === null) throw new Error('Root element not found')

createRoot(rootElement).render(
    <StrictMode>
        <PwaInstall name="Marque Central" />
        <QueryClientProvider client={queryClient}>
            <ViewportProvider><RouterProvider router={router} /></ViewportProvider>
            <DialogHost />
        </QueryClientProvider>
    </StrictMode>,
)
